import {  CommentOutlined,  ProfileOutlined, SendOutlined } from "@ant-design/icons";
import { Col, Layout, Menu, Row } from "antd";
import { useRef, useState } from "react";

import ManageRequestIndex from "./ManageRequests/ManageRequestIndex";
import MLSPortfolioIndex from "./MLSPortFolio/MlSPortFolioIndex";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import ResponsiveMenu from "apps/Common/ResponsiveMenu";



const MenuIndex = () => {
  const { Sider, Content } = Layout;
    const containerRef = useRef(null)
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const [selectedKey, setSelectedKey] = useState<any>("portfolio");
  const items = [
    {
      key: "portfolio",
      label: "Portföyüm",
      icon: <ProfileOutlined />,
      
    },
    {
      key: "sendRequest",
      label: "Giden Talepler",
      icon: <SendOutlined/>,
    },
    {
      key: "reciveRequest",
      label: "Gelen Talepler",
      icon: <CommentOutlined/>,
    },
   
   
  ];

  return (
    <Col span={24} className="">
      <Row gutter={[20,20]}  className="xl:!h-screen !bg-white" ref={containerRef}  >
      <Col xs={24}   xl={6} xxl={4} className="!rounded-lg ">
      
      <ResponsiveMenu
      
        containerRef={containerRef}
          currentStep={selectedKey}
          setCurrentStep={setSelectedKey}
          defaultSelectedKeys={["0"]}
          menuItems={items}
          onClick={(e) => setSelectedKey(e.key)}
        />
        
        

    </Col>
    <Col xs={24}  xl={18} xxl={20} className="  ">
        <Content className="!bg-white ">
        {
          (()=>{
            if(selectedKey==="portfolio")
            {
              return(
                <> <MLSPortfolioIndex/> </>
              )
            }
           
            else if(selectedKey==="sendRequest"){
              return(
                <>
               <ManageRequestIndex type="send" />
                </>
              )
            }
            else if(selectedKey==="reciveRequest"){
              return(
                <>
               <ManageRequestIndex type="recive" />
                </>
              )
            }


            return <>

            
            </>
          })()
         }
        </Content>
      </Col>
      </Row>
    
    </Col>
  );
};

export default MenuIndex;
